import { render, staticRenderFns } from "./SessionBuyInsEdit.vue?vue&type=template&id=33df1e1e&"
import script from "./SessionBuyInsEdit.vue?vue&type=script&lang=js&"
export * from "./SessionBuyInsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports